export default [
  {
    path: '/activity',
    name: 'Activity',
    component: () => import('../views/activity/Router.vue'),
    redirect: '/activity/index',
    children: [
      {
        path: 'index',
        name: 'ActivityIndex',
        component: () =>
          import('../views/activity/index.vue')
      },
      {
        path: 'rank',
        name: 'ActivityRank',
        meta: {
          title: '学分排行榜'
        },
        component: () =>
          import('../views/activity/Ranking.vue')
      },
      {
        path: 'create',
        name: 'ActivityCreate',
        component: () =>
          import('../views/activity/create.vue')
      },
      {
        path: 'refiningDetails',
        name: 'ActivityRefiningDetails',
        component: () =>
          import('../views/activity/details.vue')
      },
      {
        path: 'introduction',
        name: 'ActivityIntroduction',
        component: () =>
          import(
            '../views/activity/Introduction.vue'
          )
      }
    ]
  }
]
